import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getUserLuckyDraws, JoinLuckyDraw, } from "../../store/slices/luckydraw";
import { useDispatch, useSelector } from "react-redux";
import { FaWhatsapp, FaRegUser, FaMobileAlt, FaRegEnvelope, FaCoins, FaCalendar, FaUsers } from "react-icons/fa";
import { FaRegCopy, FaPeopleGroup } from "react-icons/fa6";
import { Link } from "react-router-dom";


const formatDate = (iso) => {
    if (!iso) return "—";
    return new Date(iso).toLocaleDateString("en-IN", {
        day: "numeric", month: "short", year: "numeric",
    });
};
const formatTime = (iso) => {
    if (!iso) return "";
    return new Date(iso).toLocaleTimeString("en-IN", {
        hour: "2-digit", minute: "2-digit",
    });
};
const formatCurrency = (val) =>
    val != null ? `₹${Number(val).toLocaleString("en-IN")}` : "₹0";

const MONTH_NAMES = ["", "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


export default function UserHome() {
    const { profile } = useSelector(
        (state) => state.auth // or state.user
    );

    const [copied, setCopied] = useState(false);

    const dispatch = useDispatch();
    const { luckyDraws = [] } = useSelector((state) => state.luckyDraw);

    useEffect(() => {
        dispatch(getUserLuckyDraws());
    }, [dispatch]);

    const activeDraw = luckyDraws?.[0];

    const username = profile?.data?.name || "-";
    const email = profile?.data?.email || "-";
    const mobile = profile?.data?.mobileNumber || "-";
    const referCode = profile?.data?.referralCode || "-";
    const subscription = profile?.data?.subscription || null;

    const handleCopy = () => {
        navigator.clipboard.writeText(referCode).catch(() => { });
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const handleWhatsApp = () => {
        const referralLink = `https://app.cashbackpromoters.com/register?ref=${referCode}`;

        const msg = encodeURIComponent(
            ` Join Cash Back Promoters and Developers!

Use my referral code: ${referCode}

Register here:
${referralLink}`
        );

        window.open(`https://wa.me/?text=${msg}`, "_blank");
    };


    const drawStats = [
        {
            icon: <FaUsers />,
            label: "Direct Referrals",
            value: subscription?.directReferrals ?? "0",
            accent: "cyan",
        },
        {
            icon: <FaPeopleGroup />,
            label: "Team Size",
            value: subscription?.teamSize ?? "0",
            accent: "gold",
            badge: true,
        },
        {
            icon: <FaCoins />,
            label: "Prize Amount",
            value: activeDraw ? formatCurrency(activeDraw.prizeAmount) : "0",
            accent: "green",
        },
        {
            icon: <FaCalendar />,
            label: "Draw Month",
            value: activeDraw
                ? `${MONTH_NAMES[activeDraw.month] || activeDraw.month} ${activeDraw.year}`
                : "0",
            accent: "purple",
        },
    ];

    // join lucky draw -- >

    const joinLuckdrawUser = () => {
        dispatch(JoinLuckyDraw());
        alert("join Lucky Draw")
    };



    return (
        <>


            <div className="breadcrumb-bar mb-2 mx-1">
                <div className="container-fluid">
                    <div className="d-flex flex-row flex-md-row align-items-md-center justify-content-between gap-2 py-2">

                        <div className="breadcrumb-left d-flex align-items-center flex-wrap">
                            <Link to="/user/home" className="breadcrumb-link active my-2">
                                Home
                            </Link>

                            {/* <span className="breadcrumb-separator mx-2">
                                <i className="bi bi-chevron-right"></i>
                            </span> */}

                            {/* <span
                                className="breadcrumb-link inactive"
                                onClick={() => navigate("/admin/addproject")}
                            >
                                Add Project
                            </span> */}
                        </div>

                        {/* <button
                            className="add-outlet-btn"
                            onClick={() => navigate("/admin/projects")}
                        >
                            <i className="bi bi-list-ul me-2"></i>
                            Projectlist
                        </button> */}

                    </div>
                </div>
            </div>

            <div className="uh-root">
                <div className="uh-blob uh-blob-1" />
                <div className="uh-blob uh-blob-2" />
                <div className="uh-blob uh-blob-3" />

                <Container fluid className="uh-container">

                    {/* Greeting */}
                    <div className="uh-greeting">
                        <div>

                            <h1 className="uh-greeting-title">
                                Welcome back <span className="uh-name-accent">{username.split(" ")[0]}!</span>
                            </h1>
                        </div>

                    </div>

                    <Row className="g-4">

                        {/* profile cards */}
                        <Col xs={12} lg={5} xl={4}>
                            <div className="uh-profile-card">
                                <div className="uh-card-shine" />
                                <div className="uh-avatar-wrap">
                                    <div className="uh-avatar-ring">
                                        <div className="uh-avatar-inner"><FaRegUser size={35} /></div>
                                    </div>

                                </div>
                                <h2 className="uh-profile-name my-3">{username}</h2>

                                <div className="uh-info-list">
                                    <div className="uh-info-row">
                                        <span className="uh-info-icon"><FaMobileAlt /></span>
                                        <span className="uh-info-text">{mobile}</span>
                                    </div>
                                    <div className="uh-info-row">
                                        <span className="uh-info-icon"><FaRegEnvelope /></span>
                                        <span className="uh-info-text">{email}</span>
                                    </div>
                                </div>
                                <div className="uh-divider" />
                                <div className="uh-refer-block">
                                    <p className="uh-refer-label">Your Referral Code</p>
                                    <div className="uh-refer-code-row">
                                        <span className="uh-refer-code">{referCode}</span>
                                        <button className="uh-copy-btn" onClick={handleCopy} title="Copy code">
                                            {copied ? "✓" : <FaRegCopy />}
                                        </button>
                                    </div>
                                </div>
                                <div className="uh-cta-row">

                                    <button className="uh-btn-whatsapp" onClick={handleWhatsApp}>
                                        <FaWhatsapp /><span>Share</span>
                                    </button>
                                </div>
                            </div>
                        </Col>

                        {/* right -- > */}
                        <Col xs={12} lg={7} xl={8}>
                            <Row className="g-4">

                                {drawStats.map((s, i) => (
                                    <Col xs={6} md={6} xl={3} key={`draw-${i}`}>
                                        <div className={`uh-stat-card uh-stat-${s.accent}`}>
                                            <div className="uh-stat-icon">{s.icon}</div>
                                            {s.badge ? (
                                                <p className="uh-stat-value">
                                                    <span style={{
                                                        display: "inline-block",
                                                        background: "#16a34a",
                                                        color: "#fff",
                                                        fontSize: "11px",
                                                        fontWeight: 700,
                                                        padding: "3px 12px",
                                                        borderRadius: "20px",
                                                        textTransform: "uppercase",
                                                        letterSpacing: ".5px",
                                                    }}>
                                                        {s.value}
                                                    </span>
                                                </p>
                                            ) : (
                                                <p className="uh-stat-value">{s.value}</p>
                                            )}
                                            <p className="uh-stat-label">{s.label}</p>
                                        </div>
                                    </Col>
                                ))}


                                <Col xs={12}>
                                    <div className="uh-draw-banner">
                                        <div className="uh-draw-banner-glow" />
                                        <div className="uh-draw-left">
                                            <p className="uh-draw-tag">LIVE NOW</p>
                                            <h3 className="uh-draw-title">
                                                {activeDraw?.title || "Mega Lucky Draw"}
                                            </h3>
                                            <p className="uh-draw-sub">
                                                Grand prize ·{" "}
                                                {activeDraw?.prizeAmount > 0
                                                    ? formatCurrency(activeDraw.prizeAmount)
                                                    : "Prize accumulating…"}
                                            </p>

                                            {/* Draw details row */}
                                            <div style={{
                                                display: "flex", gap: "18px", flexWrap: "wrap",
                                                marginTop: "10px", marginBottom: "10px",
                                            }}>
                                                <div>
                                                    <p style={{ fontSize: "10px", color: "#64748b", margin: "0 0 2px", textTransform: "uppercase", letterSpacing: ".5px" }}>
                                                        Draw Date
                                                    </p>
                                                    <p style={{ fontSize: "13px", fontWeight: 600, color: "#02224e", margin: 0 }}>
                                                        {formatDate(activeDraw?.drawDate)}{" "}
                                                        <span style={{ color: "#02224e", fontSize: "11px" }}>
                                                            {formatTime(activeDraw?.drawDate)}
                                                        </span>
                                                    </p>
                                                </div>

                                                <div>
                                                    <p style={{ fontSize: "10px", color: "#64748b", margin: "0 0 2px", textTransform: "uppercase", letterSpacing: ".5px" }}>
                                                        Entry Fee
                                                    </p>
                                                    <p style={{ fontSize: "13px", fontWeight: 600, color: "#02224e", margin: 0 }}>
                                                        {formatCurrency(activeDraw?.amount)}
                                                    </p>

                                                </div>
                                                <div>
                                                    <p style={{ fontSize: "10px", color: "#64748b", margin: "0 0 2px", textTransform: "uppercase", letterSpacing: ".5px" }}>
                                                        Created
                                                    </p>
                                                    <p style={{ fontSize: "13px", fontWeight: 600, color: "#02224e", margin: 0 }}>
                                                        {formatDate(activeDraw?.createdAt)}
                                                    </p>
                                                </div>
                                                <div>
                                                    <p style={{ fontSize: "10px", color: "#64748b", margin: "0 0 2px", textTransform: "uppercase", letterSpacing: ".5px" }}>
                                                        Winner
                                                    </p>
                                                    <p style={{ fontSize: "13px", fontWeight: 600, color: "#02224e", margin: 0 }}>
                                                        {activeDraw?.winnerId || "TBD"}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="uh-draw-right">
                                            <button className="uh-draw-cta" onClick={joinLuckdrawUser}>Join Lucky Draw</button>

                                        </div>
                                    </div>
                                </Col>


                            </Row>
                        </Col>

                    </Row>
                </Container>
            </div>
        </>
    );
}